import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import BTradesTable from './btradesTable';
import {
  getBitcoinsTrades,
  deleteBitcoinsTrade,
  tradeCompletionStatus,
  tradeApprovalStatus
} from '../services/bitcoinsTradeService';
import auth from '../services/authService';
import Spinner from './common/spinner';
import NotFound from './notFound';
import Alert from './common/alert';

class BTrades extends Component {
  state = {
    btrades: [],
    loading: false
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const btrades_response = await getBitcoinsTrades();
    this.setState({ loading: false });
    const { data: btrades } = btrades_response.data;
    this.setState({ btrades });
  }

  handleDelete = async btrade => {
    const originalBitcoinsTrades = this.state.btrades;
    const btrades = originalBitcoinsTrades.filter(b => b._id !== btrade._id);
    this.setState({ btrades });

    try {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Alert
              name="Bitcoins Trade"
              onClose={() => {
                this.setState({ btrades: originalBitcoinsTrades });
                onClose();
              }}
              onDelete={async () => {
                await deleteBitcoinsTrade(btrade._id);
                onClose();
              }}
            />
          );
        }
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast('This Bitcoin Trade has already been deleted.');

      this.setState({ btrades: originalBitcoinsTrades });
    }
  };

  handleTradeCompletionSwitch = async btrade => {
    const btrades = [...this.state.btrades];
    const index = btrades.indexOf(btrade);
    btrades[index] = { ...btrades[index] };
    //console.log(users[index]);
    btrades[index].isCompleted = !btrades[index].isCompleted;
    await tradeCompletionStatus(btrades[index]);
    this.setState({ btrades });
  };
  
  handleTradeApprovalSwitch = async btrade => {
    const btrades = [...this.state.btrades];
    const index = btrades.indexOf(btrade);
    btrades[index] = { ...btrades[index] };
    //console.log(users[index]);
    btrades[index].isApproved = !btrades[index].isApproved;
    await tradeApprovalStatus(btrades[index]);
    this.setState({ btrades });
  };

  getPagedData = () => {
    const { btrades } = this.state;

    return { data: btrades };
  };

  render() {
    const { loading } = this.state;
    const { data: btrades } = this.getPagedData();
    const { isAdmin } = auth.getCurrentUser();
    if (loading) return <Spinner message="loading page data..." />;
    return isAdmin ? (
      <React.Fragment>
        <BTradesTable
          btrades={btrades}
          onCompleteSwitch={this.handleTradeCompletionSwitch}
          onApproveSwitch={this.handleTradeApprovalSwitch}
          onDelete={this.handleDelete}
          message="Bitcoin Trades"
        />
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default BTrades;
